import React from 'react';
import PropTypes from 'prop-types';

import { PageSubTitle } from 'components/common/Elements/Elements';
import { Donut } from 'components/common/charts/charts';
import ChartBox from './ChartBox/ChartBox';

import classes from './Widgets.module.scss';

const Widgets = ({ customerId, data }) => {
  const ratingChats = {
    title: 'Chats with Rating',
    values: { current: data.chatsWRating, max: data.totalChats },
    color: 'blue'
  };

  const scoreTickets = {
    title: 'Tickets with score',
    values: { current: data.ticketsWScore, max: data.totalTickets },
    color: 'orange'
  };

  return (
    <section className={classes.charts}>
      <PageSubTitle
        hiden
        title="Tickets and chats - widgets and charts"
        size={3}
      />
      <div className={classes.widgets}>
        <Donut donatChartData={ratingChats} className={classes.donut} />
        <Donut donatChartData={scoreTickets} />
      </div>
      <ChartBox customerId={customerId} />
    </section>
  );
};

Widgets.propTypes = {
  customerId: PropTypes.string,
  data: PropTypes.object
};

export default Widgets;
